// import React from "react";

// export default function MainDashboard() {
//     const username = sessionStorage.getItem("user_name");

//     return (

//         <center>

//             <p className="college-name">
//                 Welcome  to  {username ?? "-"}
//             </p>


//         </center>

//     );
// }
import React from "react";

export default function MainDashboard() {
    const username = sessionStorage.getItem("user_name") ?? "-";

    return (
        <div style={{ minHeight: "481px", display: "flex", alignItems: "center", justifyContent: "center", background: "#ffffff" }}>
            <div style={{ textAlign: "center" }}>
                <p style={{ fontSize: "14px", color: "#7ba386", letterSpacing: "2px", marginBottom: "8px" }}>Welcome to</p>
                <h1 style={{ fontSize: "32px", color: "#005517",margin: 0 }}>
                    {username}
                </h1>
            </div>
        </div>
    );
}